// @ts-nocheck
/**
 * 動的市場システム - 名称パターンデータ
 *
 * カード名に含まれる文字列で判定する名称パターン。
 * カテゴリ（【ドラゴン】等）とは異なり、カード名で判定する。
 *
 * 例:
 * - 「ブリザードキャット・フロスト」→ nameIncludes: 'ブリザードキャット' でマッチ
 * - 「岩狸・大岩王」→ nameIncludes: '岩狸' でマッチ
 */

// ========================================
// 名称パターン一覧
// ========================================

/**
 * 名称パターンリスト
 * カード名に含まれる文字列で価格変動の対象を判定する
 */
export const NAME_PATTERNS = [
  // 炎属性系
  '岩狸',

  // 水属性系
  'ブリザードキャット',
  'ヴェルゼファール',

  // 光属性系
  '鳥民',
  'フルーツ・マリオネット',
  'リリカ',

  // 闇属性系
  '魔女',
  '黒呪',
  'ゴシック',

  // 原始属性系
  '粘液獣',
  '鎖縛',

  // 未来属性系
  '未来鴉',

  // 複数属性/なし属性系
  '虹羽密林',
  '呪術狩り',
  'ヴォランティス',
  '鉄槍騎士団',
];

// ========================================
// 名称パターン → 関連属性 マッピング
// ========================================

/**
 * 名称パターンから主な関連属性を取得するためのマッピング
 * ニュース生成時に属性を自動決定するために使用
 */
export const NAME_PATTERN_ATTRIBUTES = {
  '岩狸': '炎',
  'ブリザードキャット': '水',
  'ヴェルゼファール': '水',
  '鳥民': '光',
  'フルーツ・マリオネット': '光',
  'リリカ': '光', // 光/闇だが主に光
  '魔女': '闇',
  '黒呪': '闇',
  'ゴシック': '原始', // 闇/原始だが主に原始
  '粘液獣': '原始',
  '鎖縛': '原始',
  '未来鴉': '未来',
  '虹羽密林': null, // 複数属性
  '呪術狩り': null, // 複数属性
  'ヴォランティス': null, // 複数属性
  '鉄槍騎士団': 'なし',
};

// ========================================
// ヘルパー関数
// ========================================

/**
 * 名称パターンから関連属性を取得
 * @param {string} pattern - 名称パターン
 * @returns {string|null} 関連属性（複数属性の場合はnull）
 */
export const getAttributeForNamePattern = (pattern) => {
  return NAME_PATTERN_ATTRIBUTES[pattern] || null;
};

/**
 * カード名が指定の名称パターンにマッチするか判定
 * @param {string} cardName - カード名
 * @param {string} pattern - 名称パターン
 * @returns {boolean} マッチするかどうか
 */
export const matchesNamePattern = (cardName, pattern) => {
  return cardName && cardName.includes(pattern);
};

// ========================================
// エクスポート
// ========================================

export default {
  NAME_PATTERNS,
  NAME_PATTERN_ATTRIBUTES,
  getAttributeForNamePattern,
  matchesNamePattern,
};
